<div class="mt-24" (click)="closeEmployeePopup()">
  <div class="resource-distribution-notification" *ngIf="showNotification">
    <div class="resource-distribution-notification__content">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="#4CAF50" />
      </svg>
      <span>{{ notificationText }}</span>
    </div>
  </div>

  <div class="resource-distribution-filter mb-24">
    <div class="resource-distribution-filter__title">
      <span class="title">Районы</span>
    </div>
    <div class="resource-distribution-filter__controls">
      <div>
        <div class="resource-distribution-filter__select">
          <app-select-multiple
            [items]="districts"
            [initBy]="selectedDistricts"
            [initByKey]="'district_id'"
            [textKey]="'district_name'"
            [defaultText]="'Выберите район'"
            (callback)="onChangeDistricts($event)"
          ></app-select-multiple>
        </div>
        <button type="button" class="button" (click)="applyDistrictFilter()">Применить</button>
        <button type="button" class="ctrl link link--dotted-gray-dark" (click)="resetDistrictFilter()">Сбросить</button>
      </div>

      <ng-container *ngIf="showActionButtons">
        <div>
          <button type="button" class="button button--white" [disabled]="isSaving" (click)="cancelChanges()">Отменить</button>
          <button type="button" class="button button--yellow" [disabled]="isSaving" (click)="saveChanges()">
            <span *ngIf="!isSaving">Сохранить</span>
            <span *ngIf="isSaving">Сохранение...</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="isLoading" class="resource-distribution-loading">
    <app-loader></app-loader>
  </div>

  <div class="resource-distribution-table-container" *ngIf="!isLoading">
    <div class="resource-distribution-scrollable-section resource-distribution-scrollable-section--sticky">
      <div class="resource-distribution-table__fixed-column">
        <div class="resource-distribution-table__header-cell">
          <div class="resource-distribution-table__header-title">Сотрудники</div>
          <div class="resource-distribution-table__header-subtitle">Кол-во привязанных СИ на районе</div>
        </div>
      </div>

      <div class="resource-distribution-header-scroll" #headerScroll (scroll)="onHeaderScroll($event)">
        <div class="resource-distribution-table">
          <div class="resource-distribution-table__header">
            <div class="resource-distribution-table__districts-header">
              <div class="resource-distribution-table__district-block" *ngFor="let district of filteredDistricts; trackBy: trackByDistrict">
                <div class="resource-distribution-table__district-name">
                  <span class="resource-distribution-table__district-name-text" [title]="district.district_name">{{ district.district_name }}</span>
                  <span class="resource-distribution-table__bulk-actions">
                    <span class="resource-distribution-table__bulk-icon" title="Заполнить все ячейки района" (click)="fillDistrictCells(district.district_id, $event)"
                      ><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 7H9V3H7V7H3V9H7V13H9V9H13V7Z" fill="currentColor" /></svg
                    ></span>
                    <span
                      class="resource-distribution-table__bulk-icon resource-distribution-table__bulk-icon--danger"
                      title="Очистить все ячейки района"
                      (click)="clearDistrictCells(district.district_id, $event)"
                      ><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12C4 13.1 4.9 14 6 14H10C11.1 14 12 13.1 12 12V4H4V12ZM13 1H9.5L8.5 0H7.5L6.5 1H3V3H13V1Z" fill="currentColor" /></svg
                    ></span>
                  </span>
                </div>
                <div class="resource-distribution-table__days-row">
                  <div class="resource-distribution-table__day-cell">
                    Пн
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 1) }}</div>
                  </div>
                  <div class="resource-distribution-table__day-cell">
                    Вт
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 2) }}</div>
                  </div>
                  <div class="resource-distribution-table__day-cell">
                    Ср
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 3) }}</div>
                  </div>
                  <div class="resource-distribution-table__day-cell">
                    Чт
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 4) }}</div>
                  </div>
                  <div class="resource-distribution-table__day-cell">
                    Пт
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 5) }}</div>
                  </div>
                  <div class="resource-distribution-table__day-cell resource-distribution-table__day-cell--weekend">
                    Сб
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 6) }}</div>
                  </div>
                  <div class="resource-distribution-table__day-cell resource-distribution-table__day-cell--weekend">
                    Вс
                    <div class="resource-distribution-table__day-dash">{{ getActiveCellsCount(district.district_id, 7) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="resource-distribution-scrollable-section">
      <div class="resource-distribution-table__fixed-column">
        <div class="resource-distribution-table__fixed-body">
          <div class="resource-distribution-table__employee-cell" *ngFor="let employee of filteredEmployees; trackBy: trackByEmployee">
            <div class="resource-distribution-table__employee-name-wrapper">
              <span class="resource-distribution-table__employee-name" [title]="employee.full_name">{{ employee.full_name }}</span>
              <span class="resource-distribution-table__bulk-actions" *ngIf="employee.hasSchedule">
                <span class="resource-distribution-table__bulk-icon" title="Заполнить все ячейки сотрудника" (click)="fillEmployeeCells(employee.u_id, $event)"
                  ><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 7H9V3H7V7H3V9H7V13H9V9H13V7Z" fill="currentColor" /></svg
                ></span>
                <span
                  class="resource-distribution-table__bulk-icon resource-distribution-table__bulk-icon--danger"
                  title="Очистить все ячейки сотрудника"
                  (click)="clearEmployeeCells(employee.u_id, $event)"
                  ><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12C4 13.1 4.9 14 6 14H10C11.1 14 12 13.1 12 12V4H4V12ZM13 1H9.5L8.5 0H7.5L6.5 1H3V3H13V1Z" fill="currentColor" /></svg
                ></span>
              </span>
              <span
                *ngIf="false"
                class="resource-distribution-table__employee-ellipsis"
                [ngClass]="{
                  'resource-distribution-table__employee-ellipsis--disabled': !employee.hasSchedule,
                  'resource-distribution-table__employee-ellipsis--active': employee.hasSchedule
                }"
                [title]="!employee.hasSchedule ? 'Нет доступных действий: у сотрудника не задан график' : ''"
                (click)="toggleEmployeePopup(employee.u_id, employee.hasSchedule, $event)"
              >
                ...
              </span>
              <div class="resource-distribution-popup" *ngIf="openedPopupEmployeeId === employee.u_id" (click)="$event.stopPropagation()">
                <div class="resource-distribution-popup__item" (click)="copySchedule(employee.u_id)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13 0H3C2.448 0 2 0.448 2 1V11C2 11.552 2.448 12 3 12H13C13.552 12 14 11.552 14 11V1C14 0.448 13.552 0 13 0ZM13 11H3V1H13V11ZM11 14H1V3H0V14C0 14.552 0.448 15 1 15H11V14Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>Скопировать график</span>
                </div>
                <div class="resource-distribution-popup__item resource-distribution-popup__item--danger" (click)="deleteEmployeeSchedule(employee.u_id)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12C4 13.1 4.9 14 6 14H10C11.1 14 12 13.1 12 12V4H4V12ZM13 1H9.5L8.5 0H7.5L6.5 1H3V3H13V1Z" fill="currentColor" />
                  </svg>
                  <span>Удалить график сотрудника</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="resource-distribution-table-wrapper" #bodyScroll (scroll)="onBodyScroll($event)">
        <div class="resource-distribution-table">
          <div class="resource-distribution-table__body">
            <div class="resource-distribution-table__row" *ngFor="let employee of filteredEmployees; trackBy: trackByEmployee">
              <div class="resource-distribution-table__row-content">
                <ng-container *ngFor="let district of filteredDistricts; trackBy: trackByDistrict">
                  <div class="resource-distribution-table__district-cells">
                    <div
                      class="resource-distribution-table__cell"
                      *ngFor="let day of days; trackBy: trackByDay"
                      [ngClass]="{
                        'resource-distribution-table__cell--weekend': day === 6 || day === 7,
                        'resource-distribution-table__cell--disabled': !employee.hasSchedule,
                        'resource-distribution-table__cell--empty': !hasCellRecord(employee.u_id, district.district_id, day),
                        'resource-distribution-table__cell--add': getCellState(employee.u_id, district.district_id, day) === 'add',
                        'resource-distribution-table__cell--added': getCellState(employee.u_id, district.district_id, day) === 'added',
                        'resource-distribution-table__cell--pre-delete': getCellState(employee.u_id, district.district_id, day) === 'pre-delete'
                      }"
                      (click)="onCellClick(employee.u_id, district.district_id, day, employee.hasSchedule)"
                    >
                      <ng-container *ngIf="getCellState(employee.u_id, district.district_id, day) === 'normal'">
                        <span
                          class="resource-distribution-table__cell-icon resource-distribution-table__cell-icon--plus"
                          *ngIf="employee.hasSchedule && hasCellRecord(employee.u_id, district.district_id, day)"
                          >+</span
                        >
                      </ng-container>

                      <ng-container *ngIf="getCellState(employee.u_id, district.district_id, day) === 'add'">
                        <svg class="resource-distribution-table__cell-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.6 10.6L2.4 7.4L1.33333 8.46667L5.6 12.7333L14.6 3.73333L13.5333 2.66667L5.6 10.6Z" fill="#4CAF50" />
                        </svg>
                        <svg
                          class="resource-distribution-table__cell-icon resource-distribution-table__cell-icon--close"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.6667 4.27333L11.7267 3.33333L8 7.06L4.27333 3.33333L3.33333 4.27333L7.06 8L3.33333 11.7267L4.27333 12.6667L8 8.94L11.7267 12.6667L12.6667 11.7267L8.94 8L12.6667 4.27333Z"
                            fill="#4CAF50"
                          />
                        </svg>
                      </ng-container>

                      <ng-container *ngIf="getCellState(employee.u_id, district.district_id, day) === 'added'">
                        <svg class="resource-distribution-table__cell-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.6 10.6L2.4 7.4L1.33333 8.46667L5.6 12.7333L14.6 3.73333L13.5333 2.66667L5.6 10.6Z" fill="#fff" />
                        </svg>
                        <svg
                          class="resource-distribution-table__cell-icon resource-distribution-table__cell-icon--close"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.6667 4.27333L11.7267 3.33333L8 7.06L4.27333 3.33333L3.33333 4.27333L7.06 8L3.33333 11.7267L4.27333 12.6667L8 8.94L11.7267 12.6667L12.6667 11.7267L8.94 8L12.6667 4.27333Z"
                            fill="#fff"
                          />
                        </svg>
                      </ng-container>

                      <ng-container *ngIf="getCellState(employee.u_id, district.district_id, day) === 'pre-delete'">
                        <svg class="resource-distribution-table__cell-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 7H4V9H12V7Z" fill="#d32f2f" />
                        </svg>
                        <svg
                          class="resource-distribution-table__cell-icon resource-distribution-table__cell-icon--close"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.6667 4.27333L11.7267 3.33333L8 7.06L4.27333 3.33333L3.33333 4.27333L7.06 8L3.33333 11.7267L4.27333 12.6667L8 8.94L11.7267 12.6667L12.6667 11.7267L8.94 8L12.6667 4.27333Z"
                            fill="#d32f2f"
                          />
                        </svg>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
